import React, { useEffect, useState } from 'react';
import { Select, MenuItem, Box, SelectChangeEvent, Typography } from '@mui/material';
import i18n from 'i18next';
import './LanguageSelector.sass';
import Flag from 'react-world-flags';

const languages: { code: string; label: string; flag: string; slug: string }[] = [
  { code: 'pt', label: 'Português', flag: '🇧🇷', slug: 'br' },
  { code: 'en', label: 'English', flag: '🇺🇸', slug: 'us' },
  { code: 'es', label: 'Español', flag: '🇪🇸', slug: 'es' },
];

export const LanguageSelector = () => {
  const [language, setLanguage] = useState<string>(() => {
    return sessionStorage.getItem('language') || i18n.language || 'pt';
  });

  useEffect(() => {
    const storedLanguage = sessionStorage.getItem('language');
    if (storedLanguage && storedLanguage !== i18n.language) {
      i18n.changeLanguage(storedLanguage);
    }

    const handleLanguageChanged = (lng: string) => {
      setLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  const handleChange = (event: SelectChangeEvent) => {
    const newLang = event.target.value || 'pt';
    sessionStorage.setItem('language', newLang);
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
  };

  return (
    <Select
      value={language}
      onChange={handleChange}
      variant="outlined"
      size="small"
      className="language-select"
      renderValue={(value) => {
        const selectedLang = languages.find(lang => lang.code === value);
        return (
          <Box className="flag-label">
            <i className="country-flag">
              <Flag
                className="select-country-flag"
                code={selectedLang?.slug || 'br'}
                fallback={<span>{selectedLang?.flag}</span>}
                alt={selectedLang?.label}
              />
            </i>
            {value.toUpperCase()}
          </Box>
        );
      }}
    >
      {languages.map((lang) => (
        <MenuItem
          key={lang.code}
          value={lang.code}
          data-language={lang.code}
        >
          <Box className="language-menu-item">
            <Flag
              className="select-country-flag"
              code={lang.slug}
              fallback={<span>{lang.flag}</span>}
            />
            <Typography>{lang.label}</Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};
